import { Component, OnInit, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { CustomValidator } from 'src/app/components/Helper/custom-validator';
import { PlanDowngradeModelComponent } from 'src/app/components/plan-downgrade-model/plan-downgrade-model.component';
import { WorkexperienceModalComponent } from 'src/app/page/model/workexperience-modal/workexperience-modal.component';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { TimesPipe } from 'src/app/pipe/TimesPipe';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants, PlanOrder } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { PricePlanService } from '../../priceplanService';
interface CustomModalOptions extends ModalOptions {
  data?: any
}

interface Feature {
  name: string;
  free: boolean;
  starter: boolean;
  growth: boolean;
  scaleX: boolean;
  category?: string;
}

interface Category {
  id: string;
  name: string;
}
interface FeatureWithAvailability {
  name: string;
  availability: {
    Free: boolean;
    Pro: boolean;
    Business: boolean;
    Enterprise: boolean;
  };
}

interface FeatureWithAvailabilityList{
  groupId: any;
  featureId: string;
  featureName: string;
  availability: {
    Free: boolean;
    Starter: boolean;
    Growth: boolean;
    ScaleX: boolean;
  };
}

@Component({
  selector: 'app-plan-quota',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, PlanDowngradeModelComponent, WorkexperienceModalComponent, CommonSkeletonComponent, TimesPipe],
  templateUrl: './plan-quota.component.html',
  styleUrls: ['./plan-quota.component.scss'],
})
export class PlanQuotaComponent extends FormValidation implements OnInit {

  Plan: boolean = false;
  screendata: boolean = false;
  currentEntity: any;
  response = [];
  header: string;
  isSubmitted = false;
  isFormDirty = false;
  duplicatedata = false;
  public FORMERROR = super.Form;
  contactUs: UntypedFormGroup;
  userId: string = localStorage.getItem('userId');
  MemberShipType = localStorage.getItem("MemberShipType");
  userType = localStorage.getItem('userType');
  public lamdaurl: any = environment.LAMDA_URL;


  emailmap = '?prefilled_email=' + localStorage.getItem('userName');
  EnvPath = environment.careOnlineWebUrl + 'auth/signUp';

  constructor(private modalService: BsModalService,
    private fb: UntypedFormBuilder,
    private searchData: SearchData,
    private router: Router,
    private api: ApiService,
    private util: UtilService,
    private pricePlanService: PricePlanService,
    private gigsumoService: GigsumoService,
    // private gtag: Gtag
  ) {
    super();
  }

  planWiseOrder:any;
  async ngOnInit() {
    // Router has no `scrollPositionRestoration` configured globally, so a
    // navigation in from a long-scrolled page (e.g. recruiter dashboard's
    // "Upgrade" CTA) keeps the previous Y offset. Reset explicitly so the
    // pricing page always opens at the top — smooth scroll matches the
    // sub-tab navigation pattern used elsewhere in the app.
    window.scrollTo({ top: 0, behavior: 'smooth' });

    this.plansandfeatures();
    this.getCountry();
    this.ContactUsForm();

    this.planWiseOrder = PlanOrder;
  }



  // contact us form validation and form group
  ContactUsForm() {
    this.contactUs = this.fb.group({
      firstName: [null, [Validators.required, Validators.pattern(this.FIRST_Name.pattern), CustomValidator.max(this.FIRST_Name.max,), CustomValidator.checkWhiteSpace()]],
      lastName: [null, [Validators.required, Validators.pattern(this.LAST_NAME.pattern), CustomValidator.max(this.LAST_NAME.max), CustomValidator.checkWhiteSpace()]],
      workEmail: [null, [Validators.required, Validators.email, CustomValidator.max(this.EMAIL.max),
      Validators.pattern(this.EMAIL.pattern)]],
      phone: [null, [Validators.required, Validators.pattern(this.PHONE.pattern), CustomValidator.minmaxLetters(this.PHONE.min, this.PHONE.max)]],
      companyName: [null, [Validators.required, Validators.minLength(5)]],
      companySize: [null, Validators.required],
      country: [null, Validators.required],
      subject: 'SALE'
    });
  }
  // getter for contact us form
  get f() {
    return this.contactUs.controls;
  }

  // get all countries for contact us form to list the countries
  countries: any[] = [];
  getCountry() {
    this.api.query("country/getAllCountries").subscribe({
      next: (res: any[]) => {
        if (res && Array.isArray(res)) {
          this.countries = res;
        } else {
          console.warn('Unexpected API response format', res);
        }
      },
      error: (err) => {
        console.error("Failed to fetch countries", err);
      }
    });
  }



  entityCountConfig: any = {
    allowedJobsCandidatesCount: 0,
    allowedContactsCount: 0,
    allowedWorkspaceCount: 0,
    allowedInteractionsCount: 0,
    allowedNetworksCount: 0,
    modalTitle: '',
    isPromotional: false,
    isDowngraded: false,
    isUpgrading: false,
    showClosButton: true
  }
  bsModalRef: BsModalRef;
  openModals(planBenefits: any) {
    this.entityCountConfig.planBenefits = planBenefits
    const initialState: CustomModalOptions = {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg',
      ignoreBackdropClick: true,
      data: this.entityCountConfig
    }
    this.bsModalRef = this.modalService.show(PlanDowngradeModelComponent,
      Object.assign({ initialState }, initialState)
    );
    this.bsModalRef.content.closeBtnName = 'Close';
  }


  // API payload for stripe payment session creation;
  Payload = {
    "email": localStorage.getItem("userName"),
    "priceId": "",
    "entityId": "",
    "entityType": ""
  }

  proPlanApicall(item, param: any) {
    if (item.selected) {
      this.Payload.priceId = item.annuallyPriceId;
    } else {
      this.Payload.priceId = item.monthlyPriceId;
    }
    this.Payload.entityType = item.category;
    this.Payload.entityId = param ? param.businessId : localStorage.getItem("userId");
    this.PlanUpgradeAPIcall()
  }

  // API call session create to stripe based on that the stripe page will open for payment
  PlanUpgradeAPIcall() {
    this.util.startLoader();
    this.api.create('subscription/createCheckoutSession', this.Payload).subscribe({
      next: (response) => {
        this.util.stopLoader();
        if (response?.data?.stripeCheckoutUrl) {

          // Redirect the payment page to stripe page;
          window.location.href = response.data.stripeCheckoutUrl;

        } else {
          console.warn("Stripe Checkout URL is missing", response);
          Swal.fire({
            icon: 'error',
            title: 'Payment Error',
            text: 'Something went wrong while processing your payment. Please try again.',
          });
        }
      },
      error: (err) => {
        this.util.stopLoader();
        console.error("Error creating checkout session", err);
        Swal.fire({
          icon: 'error',
          title: 'Payment Failed',
          text: 'We encountered an error processing your payment. Please check your details and try again.',
        });
      }
    });
  }

  onPlanClick(selectedPlan: keyof typeof PlanOrder) {


  }


  openWorkExperienceForm: boolean = false;
  currentPlan: keyof typeof PlanOrder = localStorage.getItem('MemberShipType') as keyof typeof PlanOrder;

  upgradePlan(item) {
    console.log(item);
    // Here we validation plan order for the selected plan and current plan;
    // if the selected plan is less than or equal to the current plan, then return;
    const selectedPlan = item.subcriptionType as keyof typeof PlanOrder;
    if (PlanOrder[selectedPlan] <= PlanOrder[this.currentPlan]) {
      console.log("Selected plan is less than or equal to the current plan");
      return;
    } else {

      // it for plan link to open stripe path;
      let url = this.billingCycle === 'annually' ? item.yearlyPaymentLink + this.emailmap : item.monthlyPaymentLink + this.emailmap;
      // I set `selected` to `true` for the annual plan to determine whether the selection is for a year or a month;
      // Based on this, I added the necessary code. So, I kept `selected` as `true` for the annual option;
      if (this.billingCycle === 'annually') {
        item.selected = true;
      } else {
        item.selected = false;
      }
      console.log(url);
      this.util.startLoader();
      this.api.query(`user/${localStorage.getItem('userId')}`).subscribe(response => {

        if (response.code === GigsumoConstants.SUCESSCODE) {
          this.util.stopLoader();

          // work experience check to check business organization by prasanna

          if (item.category === 'INDIVIDUAL') {
            this.proPlanApicall(item, null);
          }
          else {
            let workExpData = response.workExperience;
            if (workExpData && workExpData.length > 0) {
              let currOrg = workExpData.find(x => x.currentOrganization === true);
              if (currOrg) {
                this.superAdminCheck(currOrg, item);
              }
              else {
                this.openWorkExperienceForm = true;
              }
            } else {
              this.openWorkExperienceForm = true;
            }
          }
        }
      });
    }
  }


  // Super Admin validation by Prasanna  
  superAdminCheck(data: any, item: any) {
    this.util.startLoader();
    this.gigsumoService.isSuperAdmin({ userId: localStorage.getItem('userId'), organisationId: data.organisationId }).subscribe(response => {
      if (response.code === GigsumoConstants.SUCESSCODE) {
        const code = response.data.businessStatusCode;
        const businessData = response.data.businessData;
        if ((businessData && businessData.status === 'ACTIVE' && businessData.verified === 'VERIFIED')
          && (code === GigsumoConstants.SUPERADMIN_BUSINESS_HAS_MEMBERS && this.userType == 'MANAGEMENT_TALENT_ACQUISITION' || code === GigsumoConstants.SUPERADMIN_BUSINESS_NO_MEMBERS && this.userType == 'MANAGEMENT_TALENT_ACQUISITION')) {

          setTimeout(() => {
            this.proPlanApicall(item, businessData)
          }, 2000);

          //check the usertype if its its MTA or not by monisha
        } else if ((businessData && businessData.status === 'ACTIVE' && businessData.verified === 'VERIFIED')
          && (code === GigsumoConstants.SUPERADMIN_BUSINESS_HAS_MEMBERS && this.userType != 'MANAGEMENT_TALENT_ACQUISITION' || code === GigsumoConstants.SUPERADMIN_BUSINESS_NO_MEMBERS && this.userType != 'MANAGEMENT_TALENT_ACQUISITION')) {
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
            buttonsStyling: false
          });
          swalWithBootstrapButtons.fire({
            title: 'User Type Change Required',
            text: "Only users belonging to the MTA (Manager Talent Acquisition) role can upgrade to the Starter/Growth/ScaleX plan. We can change your user type to MTA. Shall we proceed?",
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Proceed',
            allowOutsideClick: false,
            allowEscapeKey: false,
            cancelButtonText: 'Cancel',
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              this.userTypeChange(item, businessData);
            }
          });
        }
        else if (businessData != null || response.data.isEmployee || code === GigsumoConstants.NO_BUSINESS) {
          Swal.fire({
            position: "center",
            icon: "info",
            title: "Business Page Required For Starter/Growth/ScaleX Plan",
            text: "You need to be the owner of a business page to be able to upgrade to a Starter/Growth/ScaleX Plan.",
            showConfirmButton: true,
            confirmButtonText: "OK",
          }).then(response => {
            if (response.isConfirmed) {
              this.router.navigate(['/landingPage/business']);
            }
          })
        }
        this.util.stopLoader();
      }
    });
  }


  //Usertype change to MTA if user purchase business plan by monisha
  userTypeChange(item, businessData) {
    var data: any = {}
    data.userId = this.userId
    data.businessId = businessData.businessId
    this.api.create('business/transferSuperAdminToMta', data).subscribe(res => {
      this.util.stopLoader()
      if (res.code == '00000') {
        localStorage.setItem("userType", res.data.userType);
        this.userType = res.data.userType;
        var data: any = {}
        data.userType = res.data.userType
        this.searchData.setuserType(data)
        Swal.fire({
          position: "center",
          icon: "success",
          title: "User type changed successfully",
          showConfirmButton: false,
          timer: 2000,
        })
        setTimeout(() => {
          this.proPlanApicall(item, businessData)
        }, 2000);
      }
    })
  }


  // Work experience form submit after redirect to create business page by prasanna
  submitWorkExp(data: any) {
    if (data.content === "SAVESUCESS") {
      setTimeout(() => {
        this.router.navigate(['/landingPage/business']);
      }, 1000);
    }
  }

  closeModal(v: any) {
    this.openWorkExperienceForm = false;
  }




  // Price Redesign code added here by Thiru  on 10-03-2024
  billingCycle: string = 'monthly'
  planType: 'EMPLOYER' | 'AGENCY' = 'EMPLOYER';
  annualDiscountRate: number = 16
  planRespones: any = []
  tempPlanresponse: any = []
  async plansandfeatures() {

    this.screendata = false;
    let res = await this.pricePlanService.getPlan_Features();
    this.planRespones = res.data.subscriptionPlans;
    this.tempPlanresponse = res.data.subscriptionPlans;

    // Initially employee menu will display and applied the fileter here;
    this.planType = 'EMPLOYER'
    this.planRespones = this.tempPlanresponse.filter(item => item.beneficiaryType === "EMPLOYER");
    this.screendata = true;
        this.featureGroups();

  }


  // month or year change in toogle
  handleBillingCycleChange(cycle: 'monthly' | 'annually') {
    this.billingCycle = cycle;
  }


  // filter for emp and agency when i toggle 
  handlePlanTypeChange(type: 'EMPLOYER' | 'AGENCY') {
    this.planType = type;
    this.planRespones = this.tempPlanresponse.filter(item => item.beneficiaryType === type);
    this.featureGroups();
  }

  Math = Math;
  calculateDiscount(annual: number, monthly: number): number {
    return Math.round((1 - annual / (monthly * 12)) * 100);
  }


  // open contact us model
  modalRef: BsModalRef;
  openModel(template: TemplateRef<any>) {
    this.contactUs.reset();
    this.isSubmitted = false;
    this.modalRef = this.modalService.show(template);
  }




  // close model for contact us 
  closeModel() {
    this.modalRef.hide()
    this.contactUs.reset();
  }


  // Contactus form submit and api call
  onSubmit() {
    this.isSubmitted = true;
    this.contactUs.markAllAsTouched();
    if (this.contactUs.valid) {
      this.contactUs.value.subject = "SALE"
      this.apicall()
    } else if (this.contactUs.invalid) {
      return;
    }
  }

  // api call for contactus from submit
  apicall() {
    const URL = environment.LAMDA_URL_temp_contactus;
    var myHeaders = new Headers();
    let data = this.contactUs.value;
    data.source = "App";
    var raw = JSON.stringify(data);
    let requestOptions: any = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    this.duplicatedata = true;
    this.util.startLoader();
    fetch(URL, requestOptions)
      .then(response => response.json())
      .then(result => {
        this.util.stopLoader();
        this.duplicatedata = false;
        Swal.fire({
          icon: 'success',
          title: 'Thank you for contacting us!',
          text: 'One of our Customer Success managers will get in touch with you shortly.',
          showConfirmButton: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          timer: 2000,
        });
        this.modalService.hide(1);
        this.contactUs.reset()
      })
      .catch(error => {
        this.util.stopLoader()
        this.duplicatedata = false;
        console.log('error', error)
      });
  }


  showFeatureTable = true;

  // Define feature categories
  featureCategories: Category[] = [
    { id: 'profile', name: 'Profile Management' },
    { id: 'network', name: 'Networking Features' },
    { id: 'jobs', name: 'Job Management' },
    { id: 'candidates', name: 'Candidate Management' },
    { id: 'ai', name: 'AI-Powered Features' },
    { id: 'communication', name: 'Communication Tools' },
    { id: 'access', name: 'Network Access' },
    { id: 'support', name: 'Support Options' }
  ];

  // Original features list with added category field
  featuresList: Feature[] = [
    { name: 'User profile', free: true, starter: true, growth: true, scaleX: true, category: 'profile' },
    { name: 'Business profile', free: true, starter: true, growth: true, scaleX: true, category: 'profile' },
    { name: 'Unlimited connections', free: true, starter: true, growth: true, scaleX: true, category: 'network' },
    { name: 'Unlimited referral credits', free: true, starter: true, growth: true, scaleX: true, category: 'network' },
    { name: 'Social networking', free: true, starter: true, growth: true, scaleX: true, category: 'network' },
    { name: 'Workspaces', free: true, starter: true, growth: true, scaleX: true, category: 'network' },
    { name: 'Job posting', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Upgrade job', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Marketplace jobs', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Featured jobs', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Jobs from connections', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Job sharing', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Job likes', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Job views', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Job applicants', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Job pipeline activity', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Job status', free: true, starter: true, growth: true, scaleX: true, category: 'jobs' },
    { name: 'Candidate profile showcase', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Upgrade candidate', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Marketplace candidates', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Featured candidates', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Candidates from Connections', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Candidate profile sharing', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Candidate views', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Candidate likes', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Candidate resume request', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Candidate pipeline activity', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'Candidate status', free: true, starter: true, growth: true, scaleX: true, category: 'candidates' },
    { name: 'AI-powered candidate matching', free: true, starter: true, growth: true, scaleX: true, category: 'ai' },
    { name: 'AI-powered job matching', free: true, starter: true, growth: true, scaleX: true, category: 'ai' },
    { name: 'AI-powered predictive resume scoring', free: false, starter: false, growth: true, scaleX: true, category: 'ai' },
    { name: 'AI-powered predictive job scoring', free: false, starter: false, growth: true, scaleX: true, category: 'ai' },
    { name: 'Real time chat', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: '1 to 1 chat', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Group chat', free: false, starter: false, growth: true, scaleX: true, category: 'communication' },
    { name: 'Workspace chat', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Job online chat', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Candidate online chat', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Real time messaging', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: '1 to 1 messaging', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Group message', free: false, starter: false, growth: true, scaleX: true, category: 'communication' },
    { name: 'Workspace message', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Job messaging', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Candidate messaging', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Network messaging', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Business messaging', free: true, starter: true, growth: true, scaleX: true, category: 'communication' },
    { name: 'Access to recruiter network', free: true, starter: true, growth: true, scaleX: true, category: 'access' },
    { name: 'Access to freelancer network', free: true, starter: true, growth: true, scaleX: true, category: 'access' },
    { name: 'Access to bench sales network', free: true, starter: true, growth: true, scaleX: true, category: 'access' },
    { name: 'Access to TA managers network', free: false, starter: true, growth: true, scaleX: true, category: 'access' },
    { name: 'Access to job seekers network', free: false, starter: true, growth: true, scaleX: true, category: 'access' },
    { name: 'Private networks', free: true, starter: true, growth: true, scaleX: true, category: 'access' },
    { name: 'GigSumo global community membership', free: true, starter: true, growth: true, scaleX: true, category: 'access' },
    { name: 'Priority support', free: false, starter: true, growth: true, scaleX: true, category: 'support' },
    { name: 'Dedicated client success manager', free: false, starter: false, growth: true, scaleX: true, category: 'support' }
  ];


  toggleFeatureTable(): void {
    this.showFeatureTable = !this.showFeatureTable;
  }

  // Method to get features by category
  getFeaturesByCategory(categoryId: string): FeatureWithAvailability[] {
    return this.featuresList
      .filter(feature => feature.category === categoryId)
      .map(feature => ({
        name: feature.name,
        availability: {
          Free: feature.free,
          Pro: feature.starter,
          Business: feature.growth,
          Enterprise: feature.scaleX
        }
      }));
  }


  // replace static information of features list for plans
  featureGroupList:any[]=[];
  featureAvailablityList:any[]=[];
  featureGroups() {
    const planNames = ['Free', 'Starter', 'Growth', 'ScaleX'];
    const planResponses = this.planRespones;

    const featureMap = new Map<string, FeatureWithAvailabilityList>();

    // 1. Use features from first plan only as base
    const basePlan = planResponses[0];
    const baseAccessGroups = basePlan.featureAccessiblities || [];

    this.featureGroupList = baseAccessGroups;

    baseAccessGroups.forEach(group => {
      const groupId = group.groupId;
      const features = group.featureAvailablities || [];

      features.forEach(feature => {
        const key = feature.featureId;

        featureMap.set(key, {
          featureName: feature.featureName,
          featureId: feature.featureId,
          groupId: groupId,
          availability: {
            Free: false,
            Starter: false,
            Growth: false,
            ScaleX: false
          }
        });
      });
    });

    // 2. Fill in availability from all plans
    planResponses.forEach((plan, planIndex) => {
      const planKey = planNames[planIndex];
      const accessGroups = plan.featureAccessiblities || [];

      accessGroups.forEach(group => {
        const features = group.featureAvailablities || [];

        features.forEach(feature => {
          const entry = featureMap.get(feature.featureId);
          if (entry) {
            entry.availability[planKey] = feature.enabled;
          }
        });
      });
    });

    const featureList = Array.from(featureMap.values());
    this.featureAvailablityList = featureList;
    console.log('✅ Final feature list (12 expected):', featureList);

  }

  // Method to get features by category
  getFeaturesByGroupId(groupId: string){
    return this.featureAvailablityList
      .filter(feature => feature.groupId === groupId)
      
  }


}
